<template>
  <div>
    <collapse>
      <collapse-item>
        <h3 slot="title" class="mb-0">Distribuidores Asignados</h3>
        <div>
          <ul class="list-group list-group-flush list my--3">
            <li v-for="distributor in distributors" :key="distributor.id" class="list-group-item px-0">
              <div class="row align-items-center">
                <div class="col">
                  <h4 class="mb-0">
                    <router-link
                      v-if="$can('show', 'distributors')"
                      :to="{
                        name: 'DistributorShow',
                        params: { id: distributor.id },
                      }"
                    >
                      {{ distributor.name }}
                    </router-link>
                    <span v-else>{{ distributor.name }}</span>
                  </h4>
                  <div class="small mt-1"><label>CUIT:&nbsp;</label>{{ distributor.cuit }}</div>
                  <div class="small"><label>Email:&nbsp;</label>{{ distributor.email }}</div>
                  <div v-if="distributor.city" class="small">
                    <label>Localidad:&nbsp;</label>{{ distributor.city.name }},
                    {{ distributor.city.province.name }}
                  </div>
                  <div class="small"><label>Teléfono:&nbsp;</label>{{ distributor.phone }}</div>
                </div>
                <div class="col">
                  <div class="text-center">
                    <div>Fecha Ult. Visita</div>
                    <small v-if="distributor.lastVisit">
                      {{ distributor.lastVisit.visitDate | date }}
                    </small>
                    <small v-else> - </small>
                  </div>
                </div>
                <div class="col text-center">
                  <div>
                    <badge type="danger">
                      <span class="mr-1">{{ distributor.visitsCount }}</span>
                      <span v-if="distributor.visitsCount === 1">Visita</span>
                      <span v-else>Visitas</span>
                    </badge>
                  </div>

                  <div>
                    <badge type="default">
                      <span class="mr-1">{{ distributor.documentsCount }}</span>
                      <span>Archivos</span>
                    </badge>
                  </div>

                  <div>
                    <badge type="primary">
                      <span class="mr-1">{{ distributor.producersCount }}</span>
                      <span v-if="distributor.producersCount === 1">Prod. Asig.</span>
                      <span v-else>Prods. Asig.</span>
                    </badge>
                  </div>

                  <div>
                    <badge type="info">
                      <span class="mr-1">{{ distributor.plotsCount }}</span>
                      <span>Lotes</span>
                    </badge>
                  </div>
                </div>
                <div class="col-auto">
                  <router-link
                    v-if="$can('show', 'distributors')"
                    :to="{
                      name: 'DistributorShow',
                      params: { id: distributor.id },
                    }"
                    title="Ver"
                    class="btn base-button btn-outline-info btn-sm"
                  >
                    <i class="fas fa-eye"></i> VER DETALLES
                  </router-link>
                </div>
              </div>
            </li>
            <li v-if="distributors.length === 0" class="list-group-item px-0">
              <div class="row align-items-center">
                <div class="col">
                  <h4 class="mb-0">No tiene distribuidores asignados.</h4>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'DistributorsList',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    seller: {
      required: true,
      type: [Number, String],
    },
  },

  data() {
    return {
      distributors: [],
    };
  },

  created() {
    const parameters = {
      append: ['lastvisit', 'plotscount'],
      'filter[seller]': this.seller,
      include: ['city.province', 'visitsCount', 'producersCount', 'documentsCount'],
      sort: 'name',
    };

    this.$services
      .resource('distributors')
      .get(parameters)
      .then((res) => res.data.data)
      .then((data) => (this.distributors = data.distributors));
  },
};
</script>
